import type { Trigger, PopupInstance, TriggerConfig } from '../types';

export class ButtonClickTrigger implements Trigger {
	private handler: ((e: Event) => void) | null = null;
	private selector = '';

	init(popup: PopupInstance, config: TriggerConfig): void {
		this.selector = config.selector;
		if (!this.selector) return;

		this.handler = (e: Event) => {
			e.preventDefault();
			popup.show();
		};

		document.addEventListener('click', (e: Event) => {
			const target = e.target as Element;
			if (target?.closest(this.selector)) {
				this.handler?.(e);
			}
		});
	}

	destroy(): void {
		this.handler = null;
	}
}
